import { j as t } from "../../../jsx-runtime-B6kdoens.js";
import { a as n } from "../../../index-CROKJrb5.js";
import { c as d, f as g } from "../../../create-component-CBAeEoQ6.js";
import { Typography as a } from "../../Typography/index.js";
import { Rating as l, StarCount as h } from "../../Rating/index.js";
const u = d(
  "CardRating",
  g(
    ({
      className: i,
      count: r,
      defaultValue: m,
      onChange: o,
      readOnly: p,
      showCount: x = !0,
      size: c,
      value: e,
      ...f
    }, s) => /* @__PURE__ */ t.jsxs(
      "div",
      {
        className: n("cur-flex cur-items-center cur-gap-1", i),
        ...f,
        children: [
          /* @__PURE__ */ t.jsx(
            l,
            {
              defaultValue: m,
              onChange: o,
              readOnly: p,
              size: c,
              value: e
            }
          ),
          x && /* @__PURE__ */ t.jsxs(a, { ref: s, size: "meta", weight: "bold", children: [
            e,
            "/",
            h
          ] }),
          /* @__PURE__ */ t.jsxs(a, { ref: s, size: "meta", className: "cur-text-subtle", children: [
            "(",
            typeof r == "string" ? r : r == null ? void 0 : r.toLocaleString(),
            ")"
          ] })
        ]
      }
    )
  )
);
export {
  u as CardRating
};
//# sourceMappingURL=index.js.map
